/** @flow */
import React, { type ElementProps } from "react";
import { CustomInput } from "reactstrap";
import classNames from "classnames";
import "./checkbox.style.scss";

type CheckboxProps = ElementProps<typeof CustomInput>;

const Checkbox = (props: CheckboxProps) => (
  <CustomInput
    {...props}
    type="checkbox"
    className={classNames("checkbox-container", props.className)}
  />
);

Checkbox.defaultProps = {
  type: "checkbox",
};

export default Checkbox;
